var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"id":"languageSelect","dark":_vm.dark,"hide-details":"","outlined":"","items":_vm.languages,"value":_vm.lang,"label":_vm.langLabel},on:{"change":function($event){return _vm.changeLanguage($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }